export default "__VITE_ASSET__BAFpLVLy__"